/**
 * This module provides the form handler for the Wallbox-Settings of a Storage device.
 *
 * It uses a work in progress implementation of the Formik form handler.
 */

import React from 'react'
import { WallboxConfigurationModel } from 'src/Libs/wallboxes'
import { WallboxType } from 'src/Libs/wallboxes/api'
import {
  WallboxSettingsBidiForm,
  WallboxSettingsDefaultForm,
  WallboxSettingsEasyConnectForm,
  WallboxSettingsEdsnForm,
  WallboxSettingsEfyForm,
  WallboxSettingsMultiConnectForm,
} from 'src/Libs/wallboxes/components/settings/variants'
import { WallboxOcppModel } from '../../models'

interface Props {
  model: WallboxConfigurationModel
  ocppSettings: WallboxOcppModel | null
  ocppError: Error | null
  softwareVersion?: string
  hasWritingAccess?: boolean
}
const WallboxSettingsForm: React.FC<Props> = ({ model, ocppSettings, ocppError, softwareVersion, hasWritingAccess = true }) => {
  if (model.wallboxType === WallboxType.EasyConnect) {
    return <WallboxSettingsEasyConnectForm model={model} hasWritingAccess={hasWritingAccess} />
  }

  if (model.wallboxType === WallboxType.Bidi) {
    return <WallboxSettingsBidiForm model={model} hasWritingAccess={hasWritingAccess} />
  }

  if (model.wallboxType === WallboxType.MultiConnect) {
    return <WallboxSettingsMultiConnectForm model={model} hasWritingAccess={hasWritingAccess} softwareVersion={softwareVersion} />
  }

  if (model.wallboxType === WallboxType.Efy) {
    return (
      <WallboxSettingsEfyForm
        model={model}
        ocppSettings={ocppSettings}
        ocppError={ocppError}
        hasWritingAccess={hasWritingAccess}
        softwareVersion={softwareVersion}
      />
    )
  }

  if (model.wallboxType === WallboxType.EDSN) {
    return <WallboxSettingsEdsnForm model={model} hasWritingAccess={hasWritingAccess} />
  }

  return <WallboxSettingsDefaultForm model={model} hasWritingAccess={hasWritingAccess} />
}

export default WallboxSettingsForm
